<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'customerrelationships'"
      :display-name-plural="$t('entities.CustomerRelationship.Plural')"
      :display-name-singular="$t('entities.CustomerRelationship.Singular')"
      :permission-name="'Customers'"
      :allow-view="false"
      :allow-create="false"
      :allow-edit="false"
      :allow-delete="false"
      :exclude-fields="['id', 'customerId']">
      <template #cell(status)="row">
        <h4>
          <b-badge :variant="row.item.status === 'ACCEPTED' ? 'success' : 'warning'">
            {{ $t(`customerRelationshipStatus.${row.item.status}`) }}
          </b-badge>
        </h4>
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="'Zpracovat žádost'"
          :enterable="false"
          placement="top"
          v-if="$auth.check(
            'Permissions.AdminPanel.Customers.Edit'
          )">
          <b-button class="processBtn mx-1"
                    @click="$router.push({ name: 'admin.customers.edit', params: { id:row.item.customerId } });">
            <font-awesome-icon class="fa-xs"
                               icon="edit" />
          </b-button>
        </el-tooltip>
      </template>
    </DataTable>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      currentlyScanning: 0
    };
  },
  computed: {
    role() {
      return this.$store.state['vue-auth']?.user?.role || '';
    },
    isAdmin() {
      return this.role === 'Administrator';
    }
  },
  methods: {
    scanBarcode(code) {
      this.axios.post('admin/barcodes/assign', {
        CustomerId: this.currentlyScanning,
        Code: code
      }).then((response) => {
        this.$refs.DataTable.refresh();
        this.$root.$bvToast.toast('Čárový kód úspěšně přirazen', {
          title: 'Úspěch',
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        Promise.resolve(response);
      }).catch((err) => {
        this.$root.$bvToast.toast('Nepodařilo se přiradit čárový kód', {
          title: 'Nepodařilo se přiradit',
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        Promise.reject(err);
      });
    },
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.processBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #8FBC8F;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken(#8FBC8F, 10%);
    color: $text-on-secondary;
  }
}
</style>
